"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var edit_report_html_1 = __importDefault(require("./edit-report.html"));
var edit_report_controller_1 = __importDefault(require("./edit-report.controller"));
function getReportBuilderConfig(ReportBuilder) {
    return ReportBuilder.getReportBuilderConfig().then(function (response) {
        return response.data;
    });
}
getReportBuilderConfig.$inject = ["ReportBuilder"];
function getReport(ReportBuilder, $stateParams) {
    return ReportBuilder.getReportByID($stateParams.reportId).then(function (response) {
        return response.report;
    });
}
getReport.$inject = ["ReportBuilder", "$stateParams"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.reportbuilder.editreport", {
        url: "/edit-report/:reportId",
        controller: "EditReportController",
        controllerAs: "vm",
        template: edit_report_html_1.default,
        resolve: {
            ReportBuilderConfig: getReportBuilderConfig,
            report: getReport,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.reportbuilder.editreport", [])
    .config(config)
    .controller("EditReportController", edit_report_controller_1.default);
